export default {
  getUid:function(){
    var uid = window.localStorage.getItem('userId')
    return uid;
  },

  getSid:function(){
    var sid = window.localStorage.getItem('sessionId');
    return sid;
  },

  login(userId,token){
    window.localStorage.setItem('userId',String(userId));
    window.localStorage.setItem('sessionId',token);
  },
  logout(cb){
    window.localStorage.removeItem('userId');
    window.localStorage.removeItem('sessionId');
    window.localStorage.removeItem('fieldItems')
    window.localStorage.removeItem('roles');
    if(cb){
      cb();
    }
  },
  loggedIn(){
    return !!window.localStorage.getItem('userId');
  }

}


// WEBPACK FOOTER //
// ./src/common/auth.js